// extracted by mini-css-extract-plugin
export default {"root":"BulkActions_root__0J3gk","more":"BulkActions_more__4eilH","action":"BulkActions_action__TUWAP","danger":"BulkActions_danger__f+ALS"};